import { ProductionCategory, TicketType } from '@promtver/contracts';

import { ru } from '../i18n/ru';

export function categoryLabel(category: ProductionCategory | string | null | undefined): string {
  if (!category) return ru.common.notSpecified;
  const key = category as keyof typeof ru.categories;
  return ru.categories[key] ?? category;
}

export function ticketTypeLabel(ticketType: TicketType | string | null | undefined): string {
  if (!ticketType) return ru.common.notSpecified;
  const key = ticketType as keyof typeof ru.ticketTypes;
  return ru.ticketTypes[key] ?? ticketType;
}

export const productionCategories: ProductionCategory[] = [
  ProductionCategory.MachineBuilding,
  ProductionCategory.FolkCrafts,
  ProductionCategory.FoodIndustry,
  ProductionCategory.ItAndInnovation,
  ProductionCategory.Energy,
  ProductionCategory.ChemicalIndustry,
  ProductionCategory.Other,
];

export const ticketTypes: TicketType[] = [
  TicketType.Individual,
  TicketType.Group,
  TicketType.Discounted,
];
